import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { PropsWithChildren } from 'react';

import s from './Collapsed.module.scss';

type Props = PropsWithChildren<{
  className?: string;
  opened: boolean;
}>;

export const Collapsed = ({ opened, className, children }: Props) => {
  return (
    <AnimatePresence initial={false}>
      {opened && (
        <motion.div
          key="content"
          initial="collapsed"
          animate="open"
          exit="collapsed"
          variants={{
            open: { height: 'auto', opacity: 1 },
            collapsed: { height: 0, opacity: 0 },
          }}
          className={classNames(s.root, className)}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
